const MISSING_TOKEN = 0;

export default {
	MISSING_TOKEN
};



// WEBPACK FOOTER //
// ./src/utils/internal-error-codes.js